"use strict";
// loan account will be null for unassigned receivables.
Object.defineProperty(exports, "__esModule", { value: true });
exports.generateMeshes = void 0;
const common_1 = require("@finley-technologies/common");
const generateMeshes = (loanAccountToReceivables) => {
    const meshes = [];
    const receivablesToMesh = new Map();
    for (const [loanAccount, loanAccountReceivables,] of loanAccountToReceivables) {
        // for each loan account start with a new mesh.
        // will decide later if this needs to merged into existing mesh.
        let currentMesh = {
            loanAccounts: new Set([loanAccount]),
            receivables: new Set(),
        };
        let isNewMesh = true;
        // add all receivables to the mesh
        loanAccountReceivables.forEach((receivable) => {
            // check if the receivable already belongs to another mesh
            const existingMesh = receivablesToMesh.get(receivable);
            if (existingMesh) {
                isNewMesh = false;
                // merge the meshes
                currentMesh.loanAccounts.forEach((la) => {
                    existingMesh.loanAccounts.add(la);
                });
                currentMesh.receivables.forEach((r) => {
                    existingMesh.receivables.add(r);
                    receivablesToMesh.set(r, existingMesh);
                });
                currentMesh = existingMesh;
            }
            else {
                receivablesToMesh.set(receivable, currentMesh);
                currentMesh.receivables.add(receivable);
            }
        });
        if (isNewMesh) {
            meshes.push(currentMesh);
        }
    }
    // mesh is collection of assets and loan accounts.
    // there could be multiple loan Accounts in the mesh
    // if a receivable is assigned to multiple loan accounts.
    // but unassigned receivable's mesh is a special mesh, which
    // can have only one loan account. loanAccount = null.
    // ensure that there is only one mesh for unassigned receivables.
    meshes.forEach((mesh) => {
        (0, common_1.finleyAssert)(mesh.loanAccounts.size > 0 && mesh.receivables.size > 0, 'Mesh should have at least one loan account and one receivable');
        (0, common_1.finleyAssert)(!mesh.loanAccounts.has(null) || mesh.loanAccounts.size === 1, 'Unassigned receivable mesh can have only one loan account');
    });
    return meshes;
};
exports.generateMeshes = generateMeshes;
//# sourceMappingURL=Mesh.js.map